/* eslint-disable max-len */
import { ErrorCategory } from '../types'

interface ReturnObj {
  message: string;
  action?: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const exhaustiveCheck = (x: never): never => {
  throw new Error(`Unexpected object: ${x}`)
}
// Note the lang param: internationalization has not been implemented yet, keep for future-proofing
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const mapErrorCategoryToUserMsg = (cat: ErrorCategory, lang: string): ReturnObj => {
  // eslint-disable-next-line no-param-reassign
  // cat = ErrorCategory.INTERNET_DOWN

  if (cat === ErrorCategory.SERVER_NO_RESPONSE) {
    return {
      message: 'Ups.. serveren var uden for terapeutisk rækkevidde.',
      action: 'Tjek evt. din internetforbindelse og prøv igen. Kontakt os venligst, hvis problemet vedbliver.',
    }
  }

  if (cat === ErrorCategory.INTERNET_DOWN) {
    return {
      message: 'Det ser ud til, at du ikke har internetforbindelse!',
      action: 'Tjek din forbindelse og prøv igen!',
    }
  }

  if (cat === ErrorCategory.REQUEST_TIME_OUT) {
    return {
      message: 'Ups.. serverens responstid var klinisk alarmerende!',
      action: 'Prøv evt. igen. Kontakt os venligst, hvis problemet vedbliver.',
    }
  }

  if (cat === ErrorCategory.NOT_AUTHORIZED) {
    return {
      message: 'Ups.. serveren har modstand mod din handling.',
      action: 'Prøv evt. at logge ud og ind igen. Kontakt os venligst, hvis modstanden ikke opløses.',
    }
  }

  if (
    cat === ErrorCategory.AUTHENTICATION_FAILED) {
    return {
      message: 'Serveren havde problemer med at anerkende dig!',
      action: 'Prøv evt. at logge ud og ind igen. Kontakt os venligst, hvis serveren fortsat ikke vil legitimere din eksistens.',
    }
  }

  if (
    cat === ErrorCategory.REQUEST_INVALID_PARAM_VALUES
    || cat === ErrorCategory.REQUEST_PROBLEM
    || cat === ErrorCategory.RESPONSE_PROBLEM
    || cat === ErrorCategory.SERVER_PROBLEM_FATAL
  ) {
    return {
      message: 'Ups.. der er et samspils-problem med serveren!',
      action: 'Det ser ud til at terapeutisk intervention er påkrævet, men forsøg evt. igen. Kontakt os venligst, hvis problemet vedbliver.',
    }
  }

  if (cat === ErrorCategory.SERVER_PROBLEM_TRANSIENT) {
    return {
      message: 'Ups.. serveren var ikke nærværende!',
      action: 'Vent lidt og prøv igen. Kontakt os venligst, hvis problemet vedbliver.',
    }
  }

  return {
    message: 'Ups.. der opstod en udiagnosticeret dysfunktion!',
    action: 'Prøv evt. igen. Kontakt os venligst, hvis applikationen fortsat ikke kan selvregulere.',
  }
}
